// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"_0-z","dimensionLabel":"a1-z","styleChooserControlWrapper":"b1-z","styleChooserControl":"c1-z","disabled":"d1-z","giftCard":"e1-z","styleChooserText":"f1-z"};